import { cn } from "@/lib/utils";
import { Skeleton } from "../../ui/skeleton";

export type PosterCardSkeletonProps = {
  className?: string;
};

const PosterCardSkeleton = ({ className }: PosterCardSkeletonProps) => {
  return (
    <article className={cn("group relative w-full rounded-2xl p-1 border bg-white", className)}>
      <div className="relative flex h-[320px] sm:h-[400px] w-full flex-col overflow-hidden rounded-xl">
        <Skeleton className="absolute inset-0 rounded-xl bg-subtle/70" />

        {/* Favorite icon placeholder */}
        <Skeleton className="absolute left-2 top-2 z-20 h-9 w-9 rounded-full" />

        <div className="relative z-20 mt-auto flex min-w-0 flex-col gap-1.5 px-3 pb-3">
          {/* Rating badge + discount badge row */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-5 w-20 rounded-md" />
            <Skeleton className="h-5 w-12 rounded-md" />
          </div>

          {/* Title (2 lines) */}
          <div className="flex h-12 flex-col justify-center gap-1.5">
            <Skeleton className="h-3.5 w-full rounded" />
            <Skeleton className="h-3.5 w-2/3 rounded" />
          </div>

          {/* Quick icons row */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-4 rounded-full" />
          </div>

          {/* Clock + price row */}
          <div className="flex items-center justify-between gap-1">
            <Skeleton className="h-3.5 w-24 rounded" />
            <Skeleton className="h-3.5 w-14 rounded" />
          </div>

          {/* Location + price row */}
          <div className="flex items-center justify-between gap-1">
            <Skeleton className="h-3.5 w-32 rounded" />
            <Skeleton className="h-4 w-16 rounded" />
          </div>
        </div>
      </div>
    </article>
  );
};

export default PosterCardSkeleton;